import { update } from "./API";

export const UpdateCalculationSetting = async (
  calculation_setting_id: number,
  payload: any
) => {
  try {
    return await update(
      `${process.env.REACT_APP_API_URL}/calculation-settings/${calculation_setting_id}`,
      payload
    );
  } catch (err: any) {
    if (err.request) return err.request;
    if (err.response) return err.response;
    return err.message;
  }
};
